import { InlineSelect } from './InlineSelect';
export default InlineSelect;
